import React from 'react';

// Barra horizontal com gradiente — mesma paleta/técnica de gradiente de
// StatFillIcon.jsx e BusCapacityIcon.jsx (cor clara -> escura), só que em
// barra em vez de ícone: pra listas com muitas linhas (turno, área, cada
// professor de uma instituição) onde um ícone por linha ficaria poluído,
// mas ainda queremos o preenchimento proporcional bonito em vez de uma
// barra de progresso genérica.
// `compact` (opcional, default false pra não afetar quem já usa este
// componente — ver RecursosSistema.js): reduz label/barra/valor pra telas
// densas com muitas linhas ao mesmo tempo (ex.: Comparativo entre
// instituições), sem mudar o tamanho de texto (continua legível).
function ComparisonBar({
  label,
  value,
  maxValue,
  colorLight,
  colorDark,
  suffix = '',
  compact = false,
}) {
  const pct = maxValue > 0 ? Math.min(100, (value / maxValue) * 100) : 0;
  return (
    <div className="flex items-center gap-2">
      <span
        className={`${compact ? 'w-20 sm:w-28' : 'w-32 sm:w-40'} shrink-0 truncate text-xs text-gray-600 dark:text-gray-400`}
        translate="no"
        title={label}
      >
        {label}
      </span>
      <div
        className={`flex-1 ${compact ? 'h-3.5' : 'h-5'} rounded-full bg-gray-100 dark:bg-gray-800 overflow-hidden`}
      >
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{
            width: `${pct}%`,
            background: `linear-gradient(90deg, ${colorLight}, ${colorDark})`,
          }}
        />
      </div>
      <span
        className={`${compact ? 'w-10' : 'w-14'} shrink-0 text-right text-xs font-semibold text-gray-700 dark:text-gray-200`}
      >
        {value}
        {suffix}
      </span>
    </div>
  );
}

export default ComparisonBar;

// Paleta cíclica de cores (clara/escura) pra atribuir uma cor fixa por
// instituição, consistente em todas as seções da tela de Comparativo.
// Ordenada de propósito pra que as posições MAIS usadas (0, 1, 2 — quase
// sempre é isso que aparece de fato, já que a maioria das contas não tem
// mais que 2-3 instituições vinculadas) fiquem o mais distantes possível
// entre si no círculo de matizes (azul/laranja/verde ~120° cada), evitando
// o problema de antes (azul/roxo/ciano todos "da família do azul").
export const PALETA_INSTITUICOES = [
  { light: '#93C5FD', dark: '#1D4ED8' }, // azul-safira
  { light: '#FDBA74', dark: '#C2410C' }, // laranja-âmbar
  { light: '#6EE7B7', dark: '#047857' }, // verde-esmeralda
  { light: '#F9A8D4', dark: '#BE185D' }, // magenta
  { light: '#C4B5FD', dark: '#6D28D9' }, // violeta
  { light: '#67E8F9', dark: '#0E7490' }, // ciano-petróleo
];

export const corInstituicao = (index) => PALETA_INSTITUICOES[index % PALETA_INSTITUICOES.length];
